if (typeof Stickyfill !== 'undefined') {
  var sub = document.querySelectorAll('.timeline-column--sub');
  var aside = document.querySelectorAll('.timeline-column--aside');
  Stickyfill.add(sub);
  Stickyfill.add(aside);
}
